import React, { useEffect, useRef, useState } from "react";
import { Badge, Card, Col, Collapse, Form, InputGroup, Modal, Offcanvas, Row, Spinner, Table } from "react-bootstrap";
import Moment from "react-moment";
import { LuSend } from "react-icons/lu";
import { FaRegCircleXmark } from "react-icons/fa6";
import { FaUser, FaUserShield } from "react-icons/fa";
import UseToggle from "../../../../../Hooks/UseToggle";
import { NoDataFoundTable, PageLoader } from "../../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studySettingControlServices } from "../../../../../APIServices/studySettingControlServices";

const FieldReOpenQuery = ({
  Show,
  Hide,
  Title,
  setReasonMessage,
  reasonMessage,
  reOpenqueryButtonLoader,
  reOpenQueryStudySubjectFormField,
  queryData,
  setQuerySubjectType,
  querySubjectType,
  setQuerySubject,
  querySubject,
  querySubjectList
}) => {
  return (
    <>
      <Modal
        show={Show}
        onHide={Hide}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="p-0">
          <div className="d-flex justify-content-between border-bottom py-2 px-3">
            <Form.Label style={{ fontSize: 16 }} className="fw-bold mb-0">
              {Title}{" "}
            </Form.Label>
            <FaRegCircleXmark onClick={() => { Hide(); setReasonMessage("") }} style={{ fontSize: 18 }} className="text-danger CP" title="Close" />
          </div>
          <Form.Group className="py-2 px-3">
            <Form.Label className="fw-bold mb-1">
              Reason{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setReasonMessage(e.target.value)}
              value={reasonMessage}
              className="br3"
              placeholder="Reason for re-open query"
              as="textarea"
            />
            <div className="text-end mt-2 mb-0">
              <button
                disabled={!reasonMessage || reOpenqueryButtonLoader}
                onClick={() => { reOpenQueryStudySubjectFormField(queryData?.queryId); Hide(); }}
                className="updateProfile"
                style={{ fontSize: 12 }}
              >
                {reOpenqueryButtonLoader === "cancel" ? <div className="hstack gap-2">
                  <Spinner size="sm" /> Re-Opening...
                </div>
                  : " Re-Open Query"
                }
              </button>
            </div>
          </Form.Group>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FieldReOpenQuery;